// extracted by mini-css-extract-plugin
module.exports = {"periodName":"AssetStatisticsHeading_periodName__2vuX2","dateRange":"AssetStatisticsHeading_dateRange__3qWSw"};